<template>
  <div class="UseCard">
    <div class="pages">
      <div class="card-head">
        <div class="left">
          <img :src="res.img" alt />
        </div>
        <div class="right flex-1">
          <p class="text">{{res.title}}</p>
        </div>
      </div>
      <div class="rate">
        <span>综合评价</span>
        <van-rate v-model="form.rate" color="#ff8939" void-color="#ff8939" />
      </div>
      <div class="content">
        <van-field
          class="no-pad"
          v-model="form.content"
          placeholder="请输入文字评价..."
          rows="5"
          autosize
          type="textarea"
          maxlength="300"
          show-word-limit
        />
        <div class="img-list">
          <!-- <van-image
            slot="default"
            width="80px"
            height="80px"
            v-for="(v, index) in form.evaluateImgs"
            :key="index"
            :src="v"
          ></van-image>-->
          <van-uploader
            :after-read="afterRead"
            :max-count="3"
            multiple
            v-model="fileList"
            :before-delete="delet"
          >
            <van-image
              slot="default"
              width="80px"
              height="80px"
              :src="require('@/assets/images/temp/upload.png')"
            ></van-image>
          </van-uploader>
        </div>
      </div>
      <van-button type="primary" class="large-button" @click="handleRebate">提交</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Assess",
  components: {},
  data () {
    return {
      form: {
        rate: 0,
        content: "",
        evaluateImgs: []
      },
      query: {},
      res: {},
      fileList: []
    };
  },
  computed: {},
  mounted () {
    this.query = this.getQuery(this);
    if (this.query.id) {
      this.getDetail();
    }
  },
  methods: {
    // 提交
    async handleRebate () {
      if (this.form.rate === 0) {
        this.$error('请选择评分');
        return;
      }
      if (!this.form.content) {
        this.$error('请输入文字评价');
        return;
      }
      if (this.form.evaluateImgs.length === 0) {
        this.$error('请选择评价图片');
        return;
      }
      // user/userOrder/evaluate
      let res = await this.request("/user/userOrder/evaluate", {
        id: this.query.id,
        evaluateContent: this.form.content, // 评价内容
        evaluateImgs: this.form.evaluateImgs.join(","), // 图片
        evaluateScore: this.form.rate// 评分 1-5
      });
      if (res.code === 0) {
        this.$error("评价成功");
        this.laterGoBack();
      } else {
        this.$error("评价失败，" + res.msg);
      }
    },
    // /file/upload
    afterRead (file) {
      // 此时可以自行将文件上传至服务器
      // console.log(file);
      // process.env.VUE_APP_BASE_API
      let _this = this;
      let formData = new FormData();
      formData.append("file", file.file);
      var requestObj = new XMLHttpRequest();
      requestObj.open("POST", "/file/upload");
      requestObj.send(formData);
      requestObj.onload = e => {
        let res = JSON.parse(e.target.response);
        if (res.code === 0) {
          // _this.$success("上传成功");
          console.log("上传成功");
          this.form.evaluateImgs = [...this.form.evaluateImgs, res.data];
        } else {
          _this.$error(res.msg);
        }
      };
    },
    delet (option, i) {
      this.fileList.splice(i, 1);
      this.form.evaluateImgs.splice(i, 1);
    },
    // user/userOrder/get
    async getDetail () {
      let res = await this.request("/user/userOrder/get", {
        id: this.query.id
      });
      if (res.code === 0) {
        this.res = { ...res.data };
        // console.log(this.res);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.van-cell:not(:last-child)::after {
  border: 0;
}
.no-pad {
  padding: 15px 0;
}
.UseCard {
  background: #fff;
  height: 100vh;
  overflow: auto;
  .pages {
    background: #fff;
    padding: @pad;
    margin-bottom: @pad;
  }
  .grey {
    color: #585858;
  }
  .orange {
    color: #ff8939;
  }
  .card-head {
    .flex-center();
    align-items: flex-start;

    .left {
      width: 80px;
      margin-right: @pad;
      .sc(15px, #333);
      img {
        width: 100%;
        border-radius: 3px;
      }
    }
    .right {
      .text {
        font-size: 14px;
      }
    }
  }
  .rate {
    .flex-center();
    font-size: 15px;
    span {
      padding-right: 10px;
    }
    padding: @pad 0;
    justify-content: flex-start;
    border-bottom: 1px solid #e6e6e6;
  }
  .large-button {
    display: block;
    width: 80%;
    position: absolute;
    .cl();
    bottom: 20px;
  }
}
</style>